module.exports = __webpack_public_path__ + "img/green_122.c8c4e0d8.png";